export enum OrderType {
  RETAIL = 'RETAIL',
  DINE_IN = 'DINE_IN',
  TAKEOUT = 'TAKEOUT'
}

export enum OrderStatus {
  OPEN = 'Open',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
  REFUNDED = 'Refunded',
  PARTIALLY_REFUNDED = 'Partially Refunded'
}

export enum PaymentStatus {
  PENDING = 'Pending',
  PAID = 'Paid',
  FAILED = 'Failed',
  REFUNDED = 'Refunded',
  PARTIALLY_REFUNDED = 'Partially Refunded'
}

export interface ModifierOption {
  id: string;
  name: string;
  price: number;
}

export interface OrderItemModifier {
  id: string;
  name: string;
  options: ModifierOption[];
}

export interface OrderItem {
  id: string;
  name: string;
  price: number;
  quantity: number;
  modifiers: OrderItemModifier[];
  notes: string;
}

export interface Order {
  id: string;
  orderNumber: string;
  createdAt: number;
  type: OrderType;
  customerName?: string;
  subtotal: number;
  discountAmount: number;
  taxAmount: number;
  tipAmount: number;
  total: number;
  status: OrderStatus;
  paymentStatus: PaymentStatus;
  items: OrderItem[];
} 